export const SET_CONTEXT_PARAMETERS = 'contextParameters/SET_CONTEXT_PARAMETERS'
export const CLEAR_CONTEXT_PARAMETERS = 'contextParameters/CLEAR_CONTEXT_PARAMETERS'
